import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth/auth.service';
import {
  faRightFromBracket,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { getIsClerk } from '@shared/utils';
import { ButtonComponent } from '@shared/components/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ReturnToSearchDirective } from '@shared/directives';

@Component({
  selector: 'app-toolbar-navigation-actions',
  templateUrl: 'toolbar-navigation-actions.component.html',
  imports: [ButtonComponent, FaIconComponent, ReturnToSearchDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarNavigationActionsComponent {
  protected readonly isClerk = getIsClerk();
  private readonly _authService = inject(AuthService);

  protected logout() {
    this._authService.logout();
  }

  protected faRightFromBracket = faRightFromBracket;
  protected readonly faSearch = faSearch;
}
